export const parseEmojiOption = (
  text: string,
): { emoji: string; label: string } => {
  const spaceIndex = text.indexOf(' ')
  return {
    emoji: text.slice(0, spaceIndex),
    label: text.slice(spaceIndex + 1),
  }
}
